import Hero from "@/components/home/Hero";
import About from "@/components/home/About";
import Courses from "@/components/courses/Courses";
import SectionTransition from "@/components/layout/SectionTransition";
import Community from "@/components/community/Community";
import CometTransition from "@/components/animations/CometTransition";
import CallToAction from "@/components/home/CallToAction";
import Footer from "@/components/layout/Footer";

const Home2 = () => {
  return (
    <main className="relative">
      <Hero />
      <About />
      <Courses />
      <SectionTransition />
      <Community />
      <CometTransition />
      <CallToAction />
      <Footer />
    </main>
  );
};

export default Home2;
